import type { FC } from 'react';
import React from 'react';

import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button/custom-theme-button';

const subtleLinkButtonTheme = (currentTheme, themeProps) => {
	const { buttonStyles, spinnerStyles } = currentTheme(themeProps);
	return {
		buttonStyles: {
			...buttonStyles,
			color: `${token('color.text.subtle')} !important`,
			fontWeight: token('font.weight.regular'),
		},
		spinnerStyles,
	};
};

type SubtleLinkProps = {
	href: string;
	onClick: () => void;
	testId?: string;
	children?: React.ReactNode;
};

export const SubtleLink: FC<SubtleLinkProps> = ({ href, onClick, testId, children }) => {
	return (
		<Button
			href={href}
			onClick={onClick}
			theme={subtleLinkButtonTheme}
			appearance="subtle-link"
			spacing="none"
			testId={testId}
		>
			{children}
		</Button>
	);
};
